import { Block } from 'components/Block'
import { PageTitle } from 'components/PageTitle'
import { Stack } from 'components/Stack'
import { Text, Title, Title_h2_default } from 'components/Typography'
import { Button } from 'components/button/Button'
import { BlankTopNavigation } from 'components/header/topNavigationLandingPage/BlankTopNavigation'
import { Icon } from 'components/icon'
import { Layout } from 'components/layout/Layout'
import { GetStaticProps } from 'next'
import { getIntlProps } from 'utils/i18n/getIntlProps'
import { Trans, useTranslation } from 'next-i18next'
import { sendVerificationEmail } from 'utils/email'
import { getSessionValue } from 'utils/sessionStorage'
import { sessionStorageEmailKey } from 'components/auth/register/handleSignupSuccess'

export default function Page() {
  const { t } = useTranslation('auth')

  const email = getSessionValue(sessionStorageEmailKey)
  const resendEmail = async () => {
    await sendVerificationEmail(email)
  }

  return (
    <Layout header={<BlankTopNavigation />} noStickyHeader>
      <PageTitle title={t('auth.verify_email.meta_title')} />
      <Block>
        <Stack css={{ maxWidth: '600px' }} gap="2rem">
          <Title variant={Title_h2_default} as="h2">
            {t('auth.verify_email.title')}
          </Title>

          <Stack gap="4.5rem">
            <Text>
              <Trans
                t={t}
                i18nKey={
                  email != null
                    ? 'auth.verify_email.email_sent_to'
                    : 'auth.verify_email.anonymous_email_sent'
                }
                components={[<strong key="0" />]}
                values={{ email }}
              />
            </Text>
            <Text>{t('auth.verify_email.email_not_received')}</Text>
          </Stack>

          <Stack css={{ alignItems: 'flex-start' }}>
            <Button
              type="button"
              leftIcon={<Icon name="Send" />}
              variant="text"
              onClick={resendEmail}
            >
              {t('auth.verify_email.resend_email_button')}
            </Button>
          </Stack>
        </Stack>
      </Block>
    </Layout>
  )
}

export const getStaticProps: GetStaticProps = async (ctx) => {
  return { props: { ...(await getIntlProps(ctx, ['auth', 'directive'], true)) } }
}
